const pos = {
  pos: 'POS',
  create: 'Create new POS',
  add: 'Add new POS',
  code: 'POS Code',
  id: 'ID',
  name: 'Branch',
  empty: 'No POS created yet',
  pending: 'Pending action successful',
  active: 'POS activated',
  ban: 'POS blocked',
  user:'User',
  form: {
    select: 'Select branch',
    name: {
      label: 'POS Name',
      placeholder: 'Enter POS name'
    },
    pending: 'Mark as pending',
    ban: {
      text: 'Block',
      successMsg: 'POS blocked successfully',
      prompt: 'Taking this action will prevent other users from accessing information related to this POS. Do you want to block POS?',
      title: 'Block POS'
    },
    activate: {
      text: 'Activate',
      successMsg: 'POS activated successfully',
      prompt: 'Taking this action will enable other users to access information related to this POS. Do you want to activate POS?',
      title: 'Activate POS'
    },
    edit: {
      text: 'Edit',
      successMsg: 'POS edited successfully'
    },
  }
};

export default pos;